import I18n from 'I18n';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { jsx as _jsx } from "react/jsx-runtime";
export const SelectReportCheckbox = ({
  isDisabled,
  isSelected,
  tooltipMessage,
  handleSelectedChange
}) => /*#__PURE__*/_jsx(Tooltip, {
  title: tooltipMessage,
  disabled: !isDisabled,
  children: /*#__PURE__*/_jsx(Checkbox, {
    "data-test-id": isDisabled ? 'report-action-select-disabled' : 'report-action-select',
    disabled: isDisabled,
    "aria-label": I18n.text('reports.table.row.checkbox'),
    checked: isSelected,
    onChange: handleSelectedChange
  })
});